import { Bell, ClipboardList, Contact, Sparkles, Store, Timer } from 'lucide-react';
import { VERTICAL_COMPARISON } from '../comparisonMatrix';
import type { LandingConfig } from '../types';

export const beautyConfig: LandingConfig = {
  slug: 'beauty',
  namespace: 'landing-beauty',
  analyticsId: 'for-beauty',
  canonicalPath: '/for-beauty',
  ogImagePath: '/images/og-beauty.jpg',
  heroImage: '/images/hero-beauty',
  // Order matches landing-beauty:features.items[]
  featureIcons: [Store, Bell, Sparkles, ClipboardList, Contact, Timer],
  comparison: VERTICAL_COMPARISON,
};
